/**
* @name: excel-grid-show
* @author: weiyong
* @date: 2024-01-17 20:39
* @description：excel-grid-show
* @update: 2024-01-17 20:39
*/
<template>
  <div  class="prefixCexcel-grid-showls">
    <a-table :dataSource="dataSource"  size="small" :scroll="{ y: gridHeightVal }"  :columns="columnsAry" />
    <div class="flex-div" style="margin-top: 12px;justify-content: flex-end;">
      <a-button @click.stop="prePage" style="margin-right: 12px;">上一步</a-button>
      <a-button type="primary" @click.stop="importData">导入</a-button>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "excel-grid-show",
});
</script>

<script lang="ts" setup>
import {deepClone, GoingNewUtils} from 'xmgoing-utils';
import {Table as ATable,Button as AButton} from 'ant-design-vue';
interface propsType{
  columns:any,
  excelGridFlag:boolean,
  windowHeight:number,
  records:any,
}
const propsDef = withDefaults(defineProps<propsType>(),{
  columns:[],
  excelGridFlag:false,
  windowHeight:550,
  records: {},
});
const {records,columns}=toRefs(propsDef);

const columnsAry=ref([]);

const initCols=function (){
  if(unref(columns)&&unref(columns).length>0){
    unref(columns).forEach((colObjDb,index)=>{
        const colObj:any={};
        if(colObjDb.columnName==='returnMaterialDetails'){
          return;
        }
        colObj.title=colObjDb.columnCaption;
        colObj.dataIndex=colObjDb.columnName;
        colObj.key=colObjDb.columnName;
        unref(columnsAry).push(colObj)
    })
  }
}

watch(()=>unref(columns),()=>{
  initCols();
})
onMounted(()=>{
  initCols();
})
const emits=defineEmits(['prePage','nextPage']);
const gridHeightVal=ref(parseFloat(propsDef.windowHeight)-220);

const dataSource = ref(records);
const prePage=function (){
  emits('prePage',{})
}
const importData=function (){
  emits('nextPage',{})
}


</script>

<style type="text/css" lang="less">

</style>
